export const ID_LAWYERONFILE = 9999999;
export const TEXTID_LAWYERONFILE = "lddlawyeronfile";
export const LABEL_LAWYERONFILE = "Lawyer on File";
export const ID_FIRMCONTACT = 99999999;
export const TEXTID_FIRMCONTACT = "lddfirmcontact";
export const LABEL_FIRMCONTACT = "Firm Contact";

export const fileTypes = [ 
    { key: 'P', name: 'Purchase' }, 
    { key: 'S', name: 'Sale' }, 
    { key: 'M', name: 'Mortgage' }
  ];

export const taskTypes = [
    { key: 'S', name: 'System' },
    { key: 'C', name: 'Custom' },
    { key: 'U', name: 'User' }
  ];

export type TaskListColumn = {
    attrName: string;
    dataType: string;
    width: string;
    title: string;
}

export type ProvincesShortCode = "SK" | "ON" | "NS" | "MB" | "AB" | "BC"

export type FileListColumn = {
    attrName: string;
    dataType: string;
    width: string;
    title: string;
}

export type MassUpdateRequestObject = {
    updatedTaskProfile: TaskPreferenceItem,
    provinceTasks: TKeyDate[],
    taskSettings: Record<string, string>,
    ID_FIRMCONTACT: number,
    ID_LAWYERPROFILE: number,
    [key: string]: any
}

export type TKeyDate = {
    id: number,
    title?: string,
    titleFunc?: (...arg: any[]) => string,
    titleFuncCheckPSM?: boolean,
    psm: string,
    dateFunc?: string,
    province?: ProvincesShortCode[],
    date?: string
}

export type ApplicableDate = {
    id: number,
    title: string,
    date: string,
}

export type TaskPreferenceItem = {
    typeID: string,
    description: string,
    tableLinkedToID: string,
    linkID: string,
    useLawyerID: string,
    useStationID: string,
    noEdit: any,
    xcondition: any,
    loop: any,
    xmlbase: any,
    CalendarItemDate: string,
    CalendatItemDatexmlbase: any,
    offset: string,
    beforeAfter: string,
    recordID: string,
    shortDescr: string,
    startText: string,
    xpathText: string,
    endText: string,
    fileType: string,
    itemForClerk: string,
    itemForUser: string,
    UserID: string,
    output: string,
    applyToFileType: string,
    namesAssignedTo: string,
    idsAssignedTo: string,
    isDirty: string,
    CalendarItemID?: number | string | null,
}

export type FileTaskItem = {
    appId: string,
    date: string,
    matterNumber: string,
    title: string,
    typeID: number,
    ownerID: string,
    isCompleted?: number,
    notes?: string,
    overwritePerson?: number,
    overwriteDate?: number,
    userResponsible?: string,
    isActivated?: number,
    isOverwriteActivate?: number,
    xcondition?: string,
    details?: string
}

export interface TaskFilterProps {
    DueDays: number;
    BeforeAfter: string;
    Lawyer: string[];
    CalendarItemDate: string[];
    Activated: boolean;
    applyToFileType: string;
    taskType: string;
}

export const defaultFilter: TaskFilterProps = {
    DueDays: -1,
    BeforeAfter: "",
    Lawyer: [],
    CalendarItemDate: [],
    Activated: false,
    applyToFileType: "",
    taskType: ""
};

export const listColumns: FileListColumn[] = [
    {
        attrName: "output",
        dataType: "",
        width: "2%",
        title: ""
    },
    {
        attrName: "description",
        dataType: "",
        width: "35%",
        title: "Description"
    },
    {
        attrName: "Type",
        dataType: "",
        width: "7%",
        title: ""
    },
    {
        attrName: "Due",
        dataType: "",
        width: "10%",
        title: "Due"
    },
    {
        attrName: "CalendarItemDate",
        dataType: "",
        width: "15%",
        title: "Key Date"
    },
    {
        attrName: "applyToFileType",
        dataType: "",
        width: "15%",
        title: "PSM"
    },
    {
        attrName: "AssignedUsers",
        dataType: "",
        width: "25%",
        title: "Assigned Users"
    }
]

export type TaskLinkType = {
    entry: TaskPreferenceItem,
    searchText: string,
    setTask: any,
    selectedRows: any,
    setSelectedRows: any,
    setShowEditModal: any
}

export interface AddEditTaskProps {
    show: boolean;
    onHide: () => void;
    task: TaskPreferenceItem | null;
    provinceTasks: any,
    standardTasks: TaskPreferenceItem[],
    users: any,
    taskSettings: any,
    onSave?: () => void;
    province: ProvincesShortCode;
  }
  
  export const DEFAULT_TASK: TaskPreferenceItem = {
    typeID: '',
    description: '',
    tableLinkedToID: '',
    linkID: '',
    useLawyerID: '',
    useStationID: '',
    noEdit: null,
    xcondition: null,
    loop: null,
    xmlbase: null,
    CalendarItemDate: '',
    CalendatItemDatexmlbase: null,
    offset: "1",
    beforeAfter: 'before',
    recordID: '',
    shortDescr: '',
    startText: '',
    xpathText: '',
    endText: '',
    fileType: 'Purchase',
    itemForClerk: '',
    itemForUser: '',
    UserID: '',
    output: '1',
    applyToFileType: '',
    namesAssignedTo: '',
    idsAssignedTo: `${ID_FIRMCONTACT}-${ID_FIRMCONTACT}-${TEXTID_FIRMCONTACT}`,
    isDirty: '0',
    CalendarItemID: null
  };
